import store from '../store'

export default [
  {
    path: '/relatorios/contrato',
    name: 'relatorios-contrato-index',
    beforeEnter: async (to, from, next) => {
      await store.dispatch('getContratos')
      await store.commit('setRelatorio', [])
      next()
    },
    meta: {
      title: 'Relatórios de contratos',
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/contrato'
      )
    }
  },
  {
    path: '/relatorios/contrato/etapas/exibir',
    name: 'relatorios-contrato-etapas-show',
    beforeEnter: async (to, from, next) => {
      const { contrato, inicial, final } = store.getters.variaveis
      await store.dispatch('getIndustriaDoCliente', {
        id: Number(contrato)
      })
      await store.dispatch('getRelatorioContratoEtapas', {
        contrato: Number(contrato),
        inicial,
        final
      })
      next()
    },
    meta: {
      isChart: true,
      isIndustry: false,
      exportableTable: [{
        name: 'Principal',
        filename: 'principal',
        index: 0
      }, {
        name: 'Média geométrica',
        filename: 'media-geometrica',
        index: 1
      }],
      title: 'Relatório de etapas do projeto',
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/relatorio/contrato/filtros/etapa'
      )
    }
  }
]
